// Module
var code = "<tr> <td data-bind=\"text: _model.AssigneeName\"></td> <td data-bind=\"text: _model.Name\"></td> </tr>";
// Exports
export default code;